import { Phone, TrendingUp, MessageSquare } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const UseCases = () => {
  const cases = [
    {
      icon: Phone,
      title: "Inbound Customer Support",
      description: "Automate call center operations with AI agents that handle complex queries, resolve issues, and escalate when needed—24/7 availability with zero wait times.",
      benefit: "Reduce support costs by 40%",
    },
    {
      icon: TrendingUp,
      title: "Outbound Sales & Marketing",
      description: "Scale your sales outreach with AI voice agents that qualify leads, schedule demos, and nurture prospects with personalized conversations at enterprise scale.",
      benefit: "3x more qualified leads",
    },
    {
      icon: MessageSquare,
      title: "Voice Support Automation",
      description: "Integrate voice AI into your support desk for instant responses, ticket creation, status updates, and seamless handoff to human agents when required.",
      benefit: "90% faster response times",
    },
  ];

  return (
    <section className="py-24">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16 animate-fade-in">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">Powerful Use Cases</h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            From inbound support to outbound sales—transform every customer touchpoint with AI voice agents.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {cases.map((useCase, index) => (
            <Card
              key={index}
              className="p-8 hover:shadow-xl transition-all duration-300 bg-card border-border group"
            >
              <div className="w-16 h-16 rounded-xl bg-gradient-to-br from-primary to-accent flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <useCase.icon className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-2xl font-bold mb-3 text-card-foreground">{useCase.title}</h3>
              <p className="text-muted-foreground mb-4 leading-relaxed">{useCase.description}</p>
              <div className="inline-block px-4 py-2 rounded-full bg-accent/10 text-accent font-semibold text-sm">
                {useCase.benefit}
              </div>
            </Card>
          ))}
        </div>

        <div className="text-center">
          <Link to="/solutions">
            <Button size="lg" variant="outline" className="border-primary text-primary hover:bg-primary hover:text-primary-foreground">
              Explore All Solutions
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default UseCases;
